module.exports = __webpack_public_path__ + "img/logistic-drone.4d7fe5ae.png";